import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbort = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 15 16",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.66667 14.6668C11.3486 14.6668 14.3333 11.6821 14.3333 8.00016C14.3333 4.31826 11.3486 1.3335 7.66667 1.3335C3.98477 1.3335 1 4.31826 1 8.00016C1 11.6821 3.98477 14.6668 7.66667 14.6668Z",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.66699 6H5.66699V10H9.66699V6Z",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgAbort;
